import { PureComponent } from "react";

import Picture from "/components/core/picture/picture-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";

import { StyledAssetStripComponent } from "./asset-strip-component.scss";

export default class AssetStripComponent extends PureComponent {
  render() {
    const { asset, title, subtitle, height, preventSignup, signupFocusOnLoad } = this.props;

    return (
      <StyledAssetStripComponent className="asset-strip-component" style={{ height }}>
        {asset && <Picture src={asset.src} alt={asset.alt} />}

        <div className="asset-strip-content">
          <h1 className="strip-title">{title}</h1>
          <h2 className="strip-subtitle">{subtitle}</h2>

          {!preventSignup && (
            <div className="strip-signup-wrapper">
              <SignupFormComponent focusOnLoad={signupFocusOnLoad} />
            </div>
          )}
        </div>
      </StyledAssetStripComponent>
    );
  }
}

AssetStripComponent.defaultProps = {
  height: "520px"
};
